export default "__VITE_ASSET__j3MUTqv$__"